import {
  reviewFormValidator,
  type ReviewFormValidator,
} from "@redotech/redo-model/form-builder-form/db-validator/review/review-form-builder-form-validator";
import * as z from "zod";

export const getReviewFormsForTeam = {
  name: "getReviewFormsForTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(reviewFormValidator as z.ZodType<ReviewFormValidator>), // TODO (Josh) remove cast when Zod is fixed
};
